'use client';

import { useBreakpoints } from '@nettbureau/featured-core';
import {
  HStack,
  Spacer,
  Stack,
  Text,
  VStack,
  useCss,
} from '@nettbureau/vibrant-ui';
import { useTranslate } from '@tolgee/react';
import { useContext } from 'react';
import { ContainerTitle } from '../container/ContainerTitle';
import { ConfigContext } from '../provider/config-provider';
import { SearchBox } from '../shared/SearchBox';
import { getTheme, getTokenFromVibrant } from '../theme';

interface HeaderProps {
  setQuery: (q: string) => void;
  query: string;
  numResults: number;
  filteredResults?: number | null;
  title: string | null;
  hideSearchBox?: boolean;
  resultsTitle: string;
}

interface ResultsHeaderProps {
  title: string | null;
  numResults: number;
  filteredResults?: number | null;
  resultsTitle: string | null;
}

export function Header({
  setQuery,
  query,
  filteredResults,
  numResults = 0,
  title,
  hideSearchBox = false,
  resultsTitle,
}: HeaderProps) {
  const { globalThemeVariant, theme } = useContext(ConfigContext);
  const { t } = useTranslate();
  const { isMobile } = useBreakpoints();

  const textStyles = useCss((input) => ({
    ...(globalThemeVariant === 'cityListPage'
      ? {
          color: getTokenFromVibrant(
            getTheme(theme).cityListPage.numResultBox.color,
            input.theme,
          ),
        }
      : {}),
  }));
  const ResultsHeader = ({
    title,
    numResults,
    filteredResults,
    resultsTitle,
  }: ResultsHeaderProps) => {
    const hasFilteredResults =
      filteredResults !== null && filteredResults !== undefined;
    return (
      <HStack justify="start" align="baseline" gap="2xl" wrap>
        {title && <ContainerTitle title={title} alignment="left" />}
        <Text data-featured-list-results color="gray" css={textStyles}>
          {hasFilteredResults
            ? `${filteredResults} ${t('of')} ${numResults}`
            : numResults}{' '}
          {resultsTitle}
        </Text>
      </HStack>
    );
  };

  return (
    <VStack justify="center" align="stretch">
      <Stack
        direction={isMobile ? 'vertical' : 'horizontal'}
        gap={isMobile ? 'sm' : 'xl'}
        justify="space-between"
      >
        <ResultsHeader
          title={title}
          numResults={numResults}
          filteredResults={filteredResults}
          resultsTitle={resultsTitle}
        />
        {isMobile && <Spacer />}
        {hideSearchBox === false && (
          <SearchBox query={query} setQuery={setQuery} />
        )}
      </Stack>
    </VStack>
  );
}
